const en = {
  comment_group_with_N_comments_one: 'Comment group with {{count}} comment',
  comment_group_with_N_comments_other: 'Comment group with {{count}} comments',
  comment_posted_by_creator_name_time: 'Comment posted by {{name}}, {{time}}',
  name_posted_datetime: '{{name}} posted {{dateTime}}',
  role_name_posted_datetime: '{{role}} - {{name}} posted {{dateTime}}',
  award_points: 'Award points',
  retract_award_points: 'Retract Award points',
  you_liked_this_post: 'You liked this post',
  you_undo_liked_this_post: 'You undo liked this post',
  undo_like: 'Undo like',
  you_thanked_creator_name: 'You thanked {{creatorName}}',
  you_undo_thanked_creator_name: 'You undo thanked {{creatorName}}',
  undo_thank: 'Undo thank',
  delete_post: 'Delete post',
  name_liked: '{{name}} liked',
  name_thanked: '{{name}} thanked',
  click_to_view_comment_details: 'click to view comment details',
  N_likes_one: '{{count}} like',
  N_likes_other: '{{count}} likes',
  N_thanks_one: '{{count}} thank',
  N_thanks_other: '{{count}} thanks',
  N_awards_one: '{{count}} award',
  N_awards_other: '{{count}} awards',
  this_comment_has_likes_comma_thanks_and_awards: 'This comment has {{likes}}, {{thanks}} and {{awards}}',
  view_comment_stats_details: 'View comment stats details',
  N_new_message_one: '{{count}} new message',
  N_new_message_other: '{{count}} new messages',
  click_to_see_new_messages: 'Click to see new messages',
  click_to_close_new_message_info: 'Click to close new message info',
  new_comments_indicator: 'New comments indicator',

  send_a_response: 'Send a response',
  click_to_send_this_comment: 'click to send this comment',
  click_to_open_rich_text_editor: 'click to open rich text editor',
  click_to_attach_file: 'click to attach file',
  click_to_attach_image: 'click to attach image',

  load_older_comments: 'Load older comments',
  no_more_comments_to_show: 'No more comments to show',
  image_preview: 'Image Preview',

  thank_the_comment_author: 'Thank the comment author',
  like_this_comment: 'Like this comment',
  you_awarded_num_points_points_to_this_post: 'You awarded {{numPoints}} points to this post',
  delete_this_comment: 'Delete this comment',
  click_to_see_previous_post: 'click to see previous post',
  click_to_see_next_post: 'click to see next post',
  slide_to_give_award_points_to_this_post: 'slide to give award points to this post',
  click_to_award_count_points_to_this_students_post_one:
    "click to award {{count}} point to this student's post",
  click_to_award_count_points_to_this_students_post_other:
    "click to award {{count}} points to this student's post",
  click_to_cancel_awarding_points_to_this_students_post:
    "click to cancel awarding points to this student's post",
  click_to_retract_awarded_points_from_this_students_post:
    "click to retract awarded points from this student's post",
  click_to_cancel_retracting_awarded_points_from_this_students_post:
    "click to cancel retracting awarded points from this student's post",

  comment_stats: 'Comment stats',
  presenter_awarded_num_points_points: '{{presenter}} awarded {{numPoints}} points',

  are_you_sure_you_want_to_award_num_points_points_to_this_students_post:
    "Are you sure you want to award {{numPoints}} points to this student's post?",
  are_you_sure_you_want_to_retract_num_points_points_you_awarded_to_this_students_post:
    "Are you sure you want to retract {{numPoints}} points you awarded to this student's post?",

  do_you_want_to_remove_this_comment: 'Do you want to remove this comment?',
  this_comment_was_removed_by_the_author: 'This comment was removed by the author',
  this_comment_was_removed_by_article_role: 'This comment was removed by {{article}} {{role}}',

  discussion_types: 'discussion types',
  pre_submission: 'Pre-submission',
  post_submission: 'Post-submission',

  empty_comments: 'There are no comments yet.',
  empty_activity_published_comments: 'Comments will appear here once this activity is published',

  enter_comment_here: 'Enter comment here',
  enter_an_optional_comment_here: 'Enter an optional comment here',
  attached_image: 'Attached image',
};

export default en;
